/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_TitleInputs */

const en_mk_context_title = /** @type {(inputs: Mk_Context_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company memory you can see and correct`)
};

const id_mk_context_title = /** @type {(inputs: Mk_Context_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memori perusahaan yang bisa kamu lihat dan koreksi`)
};

/**
* | output |
* | --- |
* | "Company memory you can see and correct" |
*
* @param {Mk_Context_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_title = /** @type {((inputs?: Mk_Context_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_title(inputs)
	return en_mk_context_title(inputs)
});